import React from 'react';
import {
  FDLabelText,
  FDStack, FDBox,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import Divider from 'Components/UI/Divider';
import { BreakdownAmountRow } from './BreakdownAmountRow';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['moveFromLabel', 'moveToLabel', 'amountLabel', 'mobileMoveToLabel'], {
    _component: FDLabelText,
  }, overrideReadOnly);

export const Compact = ({ resource }) => {
  const amountItems = resource.attr('amountItems')?.resources().list();
  if (!amountItems) {
    return null;
  }
  return (
    <FDStack direction={'column'} flex={1} spacing={3} width={'100%'}>
      <FDBox flex={1}>
        <FDStack justifyContent={'space-between'} spacing={2}>
          <MetaControl attrName={'moveFromLabel'} resource={resource} metaOverrideSet={metaOverrides} />
          <MetaControl attrName={'amountLabel'} resource={resource} metaOverrideSet={metaOverrides} />
        </FDStack>
        <Divider fullWidth color={'attention'} />
        <FDBox paddingY={2}>
          {amountItems.map((ai) => {
            return (
              <BreakdownAmountRow
                key={ai.id()}
                icon={ai.attr('icon')}
                label={ai.attr('label')}
                amount={ai.attr('amount')}
              />
            );
          })}
        </FDBox>
      </FDBox>
      <FDBox flex={1}>
        <FDStack>
          <MetaControl attrName={'mobileMoveToLabel'} resource={resource} metaOverrideSet={metaOverrides} />
        </FDStack>
        <Divider fullWidth color={'attention'} />
        <FDBox paddingY={2}>
          <BreakdownAmountRow
            icon={resource.attr('facetAccountIcon')}
            label={resource.attr('facetAccountName')}
            amount={resource.attr('totalFundingAmount')}
          />
        </FDBox>
      </FDBox>
    </FDStack>
  );
};

Compact.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
